import { render, staticRenderFns } from "./fccDeparaComplementares.vue?vue&type=template&id=1114b502"
import script from "./fccDeparaComplementares.vue?vue&type=script&lang=js"
export * from "./fccDeparaComplementares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports